import { render, staticRenderFns } from "./AdminCreateLicense.vue?vue&type=template&id=8a28d01a"
import script from "./AdminCreateLicense.vue?vue&type=script&lang=js"
export * from "./AdminCreateLicense.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports